<template>
  <div class="public-content theme-management">
    <div class="region-title" style="background: #fff">运费模板</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0;font-weight: 500;">模板名称:</span>
        <el-input placeholder="请输入模板名称" v-model="moduleName" class="input-with-select" style="width:300px;">
          <el-button slot="append" icon="el-icon-search" style="width:20px;" @click="getModuleList"></el-button>
        </el-input>
      </div>
      <div>
        <el-button :type="status == 'true' ? '' : 'primary'" @click="createTemplate" :disabled="status == 'true' ? true : false">新建模板</el-button>
        <!-- <el-button :type="tableData.length > 0 ? '' : 'primary'" round @click="createTemplate" >新建模板</el-button> -->
      </div>
    </div>
    <div class="data-list">
      <el-empty description="暂无数据" v-if="!tableData.length"></el-empty>
      <div v-for="item in tableData" :key="item.mouldId" style="margin-top: 10px;background-color: #F5F7FA;padding: 10px;">
        <div style="display: flex; align-items: center;  justify-content:space-between;">
          <div style="font-weight: bold;">{{ item.mouldName }}</div>
          <div style="display: flex;">
            <div class="addRess" @click="moduleId = item.mouldId, addAddressType = 1, deleteDialog = true">删除</div>
            <div class="addRess" @click="editTemplate(item.mouldId)">修改</div>
          </div>
        </div>
        <div style="color:#aaa;font-size:13px;margin:10px 0;">发货地区：山东省济南市 最后修改时间：{{ item.dateUpdated }}</div>
        <el-table :data="item.moduleFeeList" style="width: 100%;margin-top: 20px;" row-key="id" border>
          <el-table-column min-width="100px" prop="area" label="运送地区">
            <template v-slot="scope">
              <span v-if="scope.row.isDefault === 1">默认运费</span>
              <span v-else>{{ scope.row.area }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100px" prop="freeRule" label="计费规则">
            <template v-slot="scope">
              <div v-if="scope.row.feeType == 3">满{{ scope.row.freeShippingPrice }}元包邮</div>
              <div v-else>
                <span>{{ scope.row.within }}</span>{{ item.feeType === 1 ? 'kg' : '件' }}以内，<span>{{ scope.row.withinPrice }}</span>元，每增加{{ scope.row.everyIncrease }}{{ item.feeType === 1 ? 'kg' : '件'
                }}，增加运费{{ scope.row.everyIncreasePrice }}元
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--    分页-->
        <!-- <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination> -->
      </div>
    </div>
    <!-- 确认删除 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteTemplate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import VPagination from '@/components/Pagination/index.vue'
import { moduleList, deleteByModuleId } from '@/api/pms'
export default {
  name: 'freight-query',
  // components: {
  //   VPagination
  // },
  data () {
    return {
      deleteDialog: false,
      moduleId: 0,
      moduleName: '',
      status: 'true',
      tableData: [],
      queryInfo: {
        total: 0,
        pageNum: 1, // 当前显示第几页
        pageSize: 10 // 每一页显示条数
      }
    }
  },
  created () {
    // this.getTheme(this.queryInfo)
    this.getModuleList()
  },
  methods: {
    createTemplate () {
      this.$router.push({
        path: '/addFreight'
      })
    },
    editTemplate (id) {
      this.$router.push({
        path: '/addFreight',
        query: {
          id: id
        }
      })
    },
    deleteTemplate () {
      deleteByModuleId(this.moduleId).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getModuleList()
        }
        this.deleteDialog = false
      })
    },
    getModuleList () {
      moduleList({
        pageNum: this.queryInfo.pageNum,
        pageSize: this.queryInfo.pageSize,
        vo: { moduleName: this.moduleName, moduleType: 'PC' }
      }).then(res => {
        if (res.data.data) {
          this.queryInfo.total = res.data.data.total
          // 将包邮的数据过滤出来
          this.tableData = res.data.data.records.map(e => {
            e.moduleFeeList = e.moduleFeeList.filter(a => a.isDefault !== 2)
            return e
          })
          this.status = res.data.status
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.add-category {
  justify-content: space-between;
}

.keywords {
  .el-input {
    width: 180px;
  }
}

.addRess {
  font-size: 13px;
  border: 1px solid #409EFF;
  color: #409EFF;
  border-radius: 2px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  margin-right: 20px;
  padding: 0 10px;
}

/deep/ .el-button.is-disabled {
  color: #fff !important;
  background-color: #C0C4CC !important;
}
</style>
